import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export class DatenverwaltungBundeslaender extends React.Component<{}, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
         return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_BUNDESLAND}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    tablePageSize={16}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_BUNDESLAND)}
                    showColumnsHelp={true}
                />
            </div>
        );
    }
}
